<template>
  <div :class="$style['agent-select-product-dialog']">
    <el-dialog :visible="dialogVisible" :title="dialogTitle" @close="cancel">
      <pt-page-search @search="search" @emptySearch="emptySearch" :isAddrouter="false" :class="$style['select-hospital-search']" :searchKey="searchKey"></pt-page-search>
      <pt-page-factor-filter :labels="doctorSelectTable" v-model="params" isQueryRouter ref="filter" @Filter="filter">
        <el-button type="primary" @click="filter()">筛选</el-button>
        <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
      </pt-page-factor-filter>
      <pt-select-list @getTableData="getTableData" :maxPage="5" :page-size="pageSize" :table-data="tableData"
        :tableLabels="tableLabels" :total-count="totalNumber" @selected="selected" keys="name" showName="name"
        :selectedRows="select_labels" ref="selectList" showBeforParams="type"></pt-select-list>
      <div class="button-div">
        <el-button type="primary" @click="submit">选择</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  emptyObject
} from '@/utils/lifebankUtils'
import {
  doctorDialogLabels,
  doctorSelectTable
} from 'cps/hospital-and-doctor-manage/hospital-and-doctor-manage.js'
export default {
  name: 'hospital-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: ''
    },
    pageSize: {
      type: Number,
      default: 6
    },
    selectLabels: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      doctorSelectTable: doctorSelectTable,
      tableLabels: doctorDialogLabels,
      totalNumber: 0,
      select_labels: JSON.parse(JSON.stringify(this.selectLabels)),
      tableData: [],
      page: 0,
      select_row: JSON.parse(JSON.stringify(this.selectLabels)),
      params: {},
      paramsData: {},
      searchKey: null
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        this.getTableData(0)
      }
    },
    selectLabels: {
      handler: function (val) {
        this.select_labels = JSON.parse(JSON.stringify(val))
        this.searchKey = ''
      }
    }
  },
  methods: {
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      this.$set(this.paramsData, 'searchKey', val)
      // this.paramsData.searchKey = val
    },
    emptySearch () {
      console.log('search')
      this.$set(this.paramsData, 'searchKey', null)
      this.searchKey = null
    },
    getCompanyList () {
      let data = {
        pageableParam: {
          page: 0,
          size: 9999
        },
        type: 'BRANCH'
      }
      this.$store.dispatch('getBranchCompanyList', data).then(res => {
        var newArr = []
        res.data.forEach(ele => {
          var obj = {}
          obj.value = ele.id
          obj.label = ele.fullName
          newArr.push(obj)
          this.doctorSelectTable.forEach(item => {
            if (item.value === 'branchId') {
              item.options = newArr
            }
          })
        })
      }).catch(err => {
        this.$message.error(err || '获取分/子公司列表失败')
      })
    },
    cleanParams () {
      emptyObject(this.params)
      this.filter()
    },
    filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
        if (!isFromRouter) {
          this.searchKey = null
          if (this.params.searchKey) {
            this.$delete(this.params, 'searchKey')
          }
          this.$refs.filter.getAddRouter(this.params)
        }
      }
      this.paramsData = JSON.parse(JSON.stringify(this.params))
    },
    selected (val) {
      // this.select_row = data
      // this.select_labels = this.select_row
      this.select_row = JSON.parse(JSON.stringify(val))
      this.select_labels = JSON.parse(JSON.stringify(this.select_row))
      this.$emit('selectMealRow', val)
    },
    submit () {
      this.$emit('selectHospitalList', this.select_row)
      this.$emit('close')
    },
    cancel () {
      this.$emit('close')
    },
    getTableData (page, next) {
      let data = {
        ...this.paramsData,
        pageableParam: {
          page: page,
          size: this.pageSize
        }
      }
      this.$store.dispatch('getHospitalList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取医院列表失败')
      })
    }
  },
  created () {
    this.getCompanyList()
  }
}

</script>
<style module lang="less">
  @import "~less/var";
  .agent-select-product-dialog {
    :global {
      .el-dialog__body{
        padding-top: 10px;
      }
      .el-dialog{
        width: 70%
      }
      .el-pagination {
        justify-content: flex-start !important;
      }

      .el-radio__label {
        display: none;
      }

      .el-radio__inner {
        border: 1px solid @mainColor;
        border-radius: 50%
      }
      .el-input,
      .el-input__inner {
        max-width: 2rem !important
      }
      .el-input--suffix .el-input__inner {
        min-width: 2rem !important
      }
    }
  }
.select-hospital-search{
  width: 100%;
  display: flex;
  max-width: 600px;
  :global{
    .el-input{
      flex: 1;
      max-width: 100%!important;
      input{
        max-width: 100%!important
      }
    }
  }
}

</style>
